
export const NumberFormat = (money: any) => {
  const roundedMoney = Math.round(Number(money));
 return new Intl.NumberFormat('th-TH', {
  style: 'decimal',
  // currency: 'THB'
}).format(roundedMoney);
};

export const NumberFormatThaiBath = (money: any) => {
 return new Intl.NumberFormat('th-TH', {
  style: 'currency',
  currency: 'THB'
}).format(money);
};


export const NumberFormatDigi = (money: any) => {
  const roundedMoney = parseFloat(money.toFixed(2));
  // const roundedMoney = Math.round(Number(money));
  return new Intl.NumberFormat('th-TH', {
    style: 'decimal',
    minimumFractionDigits: 2, // Ensure that there are always two decimal places
    maximumFractionDigits: 2  // Ensures that no more than two decimal places are shown
    // currency: 'THB'
  }).format(roundedMoney);
};
